module.exports = " <div> <relate-fieldtype :data.sync=data :name=name :config=adjustedConfig v-ref:relate></relate-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/TaxonomyFieldtype.vue
// module id = 751
// module chunks = 0